// NFC Token Portal — the strings 18_NFCPortal.jsx still wrote in English (its labels are `nfc.` in i18n.js), in the
// portal's four languages (2026-10-21). `approve` is the Approve button's tooltip, which asked for a key that never existed.
const en = {
  approve: 'Approve',
  loadFailed: 'Failed to load',
  saveFailed: 'Save failed',
  submitFailed: 'Submit failed',
  deleteFailed: 'Delete failed',
  approveFailed: 'Approve failed',
  rejectFailed: 'Reject failed',
  updateFailed: 'Update failed',
  downloadFailed: 'Download failed',
  validateFailed: 'Could not validate: {{error}}',
  errorWord: 'error',
  validateNow: 'Could not validate replacement tokens now: {{error}}',
};

const ko = {
  approve: '승인',
  loadFailed: '불러오지 못했습니다',
  saveFailed: '저장 실패',
  submitFailed: '제출 실패',
  deleteFailed: '삭제 실패',
  approveFailed: '승인 실패',
  rejectFailed: '반려 실패',
  updateFailed: '업데이트 실패',
  downloadFailed: '다운로드 실패',
  validateFailed: '검증할 수 없습니다: {{error}}',
  errorWord: '오류',
  validateNow: '지금은 교체 토큰을 검증할 수 없습니다: {{error}}',
};

const vi = {
  approve: 'Duyệt',
  loadFailed: 'Không tải được',
  saveFailed: 'Lưu không thành công',
  submitFailed: 'Gửi duyệt không thành công',
  deleteFailed: 'Xóa không thành công',
  approveFailed: 'Duyệt không thành công',
  rejectFailed: 'Từ chối không thành công',
  updateFailed: 'Cập nhật không thành công',
  downloadFailed: 'Tải xuống không thành công',
  validateFailed: 'Không kiểm tra được: {{error}}',
  errorWord: 'lỗi',
  validateNow: 'Hiện không kiểm tra được các token cần thay: {{error}}',
};

const zh = {
  approve: '批准',
  loadFailed: '加载失败',
  saveFailed: '保存失败',
  submitFailed: '提交失败',
  deleteFailed: '删除失败',
  approveFailed: '批准失败',
  rejectFailed: '驳回失败',
  updateFailed: '更新失败',
  downloadFailed: '下载失败',
  validateFailed: '无法验证：{{error}}',
  errorWord: '错误',
  validateNow: '暂时无法验证替换令牌：{{error}}',
};

const dictionary = { ns: 'xNfc', en, ko, vi, zh };

export default dictionary;
